module.exports = __webpack_public_path__ + "img/item-5-3.83928512.png";